import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ButtonService {
  private _btnClicked: Subject<string> = new Subject<string>();

  /**
   * Metoda ustawiająca kolejną wartość w `_btnClicked`.
   * @param instanceId - id instancji buttona.
   *  Potrzebne w przypadku gdy na 1 widoku posiadamy np. 2 przyciksi formularza.
   */
  onButtonClick(instanceId: string) {
    this._btnClicked.next(instanceId);
  }

  getButtonClickListener(): Observable<string> {
    return this._btnClicked.asObservable();
  }
}
